import { State } from './types';

const INIT_STATE: State = {
  account: null,
  tips: null,
  importRecord: null,
  first: null,
  web3Provider: null,
  txHash: null,
  txHashList: []
};

export default INIT_STATE;
